export default "__VITE_ASSET__CKNxJMD4__"